

<template>
  <div class="main">
    <MyHeader index="5"></MyHeader>
    <div class="titleIfo">
      <div class="container" v-if="this.$i18n.locale == 'zh_CN'">
        <h2>新闻</h2>
        <h3>News</h3>
      </div>
      <div class="container" v-if="this.$i18n.locale == 'en_US'">
        <h2>News</h2>
        <h3>新闻</h3>
      </div>
    </div>
    <div class="resourceInfo">
		
      <div class="container">
      
       <nav aria-label="Breadcrumb" class="breadcrumb2">
		  <ul>
			<li><a href="/">{{ $t("header.home") }}</a></li>
			<li><span style="margin-bottom:10px;"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 2 16 16">
  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
</svg></span></li>
			<li><a href="/dist/news/70/2">{{$t("header.newsArchive") }}</a></li>
		    <li><span style="margin-bottom:10px;"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 2 16 16">
  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
</svg></span></li>
				
			<li><span aria-current="page">资讯详情</span></li>
		  </ul>
		</nav>
		
        <div class="info">
          <h2 class="title" v-if="this.$i18n.locale == 'zh_CN'">
            {{ info.name }}
          </h2>
          <h2 class="title" v-if="this.$i18n.locale == 'en_US'">
            {{ info.name_en }}
          </h2>

          <h3 class="publish">
            <b v-if="this.$i18n.locale == 'zh_CN'"
              >{{ $t("label.author") }}{{ info.author }}</b
            >
            <b v-if="this.$i18n.locale == 'en_US'"
              >{{ $t("label.author") }}{{ info.author_en }}</b
            >

            <i>{{ $t("label.release") }}{{ info.release_time }}</i>
          </h3>
          <h5 class="subtitle" v-if="info.brief">
            {{ $t("label.abstract") }}
            <span v-if="this.$i18n.locale == 'zh_CN'">{{ info.brief }}</span>
            <span v-if="this.$i18n.locale == 'en_US'">{{ info.brief_en }}</span>
          </h5>

          <div
            v-if="this.$i18n.locale == 'zh_CN'"
            class="newsInfo ql-editor"
            v-html="info.content"
            style="margin-top: 30px; margin-bottom: 30px"
          ></div>
          <div
            v-if="this.$i18n.locale == 'en_US'"
            class="newsInfo ql-editor"
            v-html="info.content_en"
            style="margin-top: 30px; margin-bottom: 30px"
          ></div>
        </div>
        <div class="otherList">
          <div class="title fa-Middle">
            <img src="./image/resource.png" alt="resource" />
            <h3>{{ $t("label.news") }}</h3>
          </div>

          <div class="otherInfo">
            <h2 class="infoTitle" v-if="flag">{{ $t("label.othernews") }}</h2>
            <ul class="list">
              <li v-for="(item, index) in datalist" v-if="index < 3">
                <router-link
                  :to="{ name: 'newsInfo', params: { id: item.id } }"
                >
                  <h4 v-if="lang == 'zh_CN'">{{ item.name }}</h4>
                  <h4 v-if="lang == 'en_US'">{{ item.name_en }}</h4>
                  <h5 v-if="lang == 'zh_CN'">
                    {{ item.author }} {{ item.issue }}
                  </h5>
                  <h5 v-if="lang == 'en_US'">
                    {{ item.author_en }} {{ item.issue }}
                  </h5>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <MyFooter></MyFooter>
  </div>
</template>

<script>
import MyHeader from "./common/MyHeader";
import MyFooter from "./common/MyFooter";
import filter from "../filter.js";
import {
  createArticle,
  getArticleList,
  getArticleDetails,
  deleteArticle,
  putArticle,
  getRecommend,
} from "@/services/article";
export default {
  name: "NewsInfoPage",
  components: { MyHeader, MyFooter },
  data() {
    return {
      id: this.$route.params.id,
      info: {
        attachment: "",
        brief: "",
        attachment_name: "",
      },
      category: {
        recommend_id: this.$route.params.id,
        category_id: [69, 70, 71],
        page_size: 2,
      },
      moreList: [],
      flag: true,
      datalist: [],
      lang: this.$i18n.locale,
    };
  },
  mounted() {
    this.getDetails(this.id);
    this.getList();
  },
  watch: {
    $route(to, from) {
      console.log(to.params.id);

      this.category.recommend_id = to.params.id;
      this.getDetails(to.params.id);
      this.getList();
    },
  },
  methods: {
    getDetails(id) {
      getArticleDetails(id)
        .then((res) => {
          res.release_time = filter.dateFormat(res.release_time, "yyyy-mm-dd");
          this.info = res;

          //  localStorage.setItem("referer","news_detail");
          //                     localStorage.setItem("category",res.category_id);

          if (this.$i18n.locale == "en_US") {
          }
        })
        .catch((err) => {});
    },
    getList() {
      getRecommend(this.category)
        .then((res) => {
          let list = res.items;
          for (var i in list) {
            let item = list[i];
            item.issue = filter.dateFormat(item.release_time, "yyyy-mm-dd");
          }
          this.moreList = list;
          this.datalist = this.moreList.reverse();
          console.log(this.datalist, 11);
          if (this.datalist.length == 0) {
            this.flag = false;
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="scss" >
.main {
  .titleIfo {
    width: 100%;
    height: 380px;
    background: url("./image/news.jpg") no-repeat center center;
    background-size: cover;

    .container {
      h2 {
        padding-top: 180px;
        text-align: center;
        color: #ffffff;
        height: 42px;
        font-size: 32px;
        font-weight: bold;
        line-height: 42px;
      }

      h3 {
        text-align: center;
        height: 29px;
        font-size: 22px;
        line-height: 29px;
        color: #ffffff;
      }
    }
  }
  .resourceInfo {
    .container {
      padding-top: 30px;
      padding-bottom: 48px;
      overflow: hidden;
      .info {
        width: 794px;
        float: left;
        .title {
          font-size: 26px;
          color: #191919;
          line-height: 42px;
          font-weight: bold;
        }
        .publish {
          margin-top: 20px;
          font-size: 12px;
          color: #a0a0a0;
          line-height: 16px;
          overflow: hidden;
          b {
            &:after {
              content: "  ｜  ";
            }
          }
          &:after {
            margin-top: 33px;
            content: "";
            display: block;
            width: 40px;
            height: 3px;
            background-color: #888888;
          }
        }
        .subtitle {
          margin-top: 28px;
          font-size: 16px;
          color: #999;
          line-height: 34px;
          margin-bottom: 32px;
        }
        .newsInfo {
          .tips {
            margin-top: 40px;
            font-size: 18px;
            color: #191919;
            height: 24px;
            line-height: 24px;
            font-weight: bold;
          }
          p {
            margin-bottom: 10px;
            font-size: 16px;
            color: #252525;
            line-height: 34px;
            width: 100%;
          }
          img {
            border: none;
            margin-bottom: 48px;
          }
        }

        h6 {
          line-height: 18px;
          height: 18px;
          font-size: 12px;
          overflow: hidden;
          margin-top: 16px;
          i {
            display: block;
            color: #666666;
            float: left;
          }
          a {
            overflow: hidden;
            display: block;
            float: left;
            b {
              float: left;
              color: #0191ff;
              line-height: 18px;
              height: 18px;
              display: inline-block;
            }
            &:before {
              float: left;
              display: inline-block;
              width: 14px;
              height: 18px;
              content: " ";
              background: url("./image/rarzip.png") no-repeat center center;
              margin-right: 8px;
            }
          }
        }
      }
      .otherList {
        width: 270px;
        float: right;
        .title {
          height: 60px;
          background-image: linear-gradient(-49deg, #76ec85 0%, #44be86 97%);
          border-radius: 3px;
          img {
            margin-top: 2px;
          }
          h3 {
            margin-left: 10px;
            font-size: 24px;
            font-weight: bold;
            color: rgba(255, 255, 255, 1);
            line-height: 24px;
          }
        }
        .otherInfo {
          margin-top: 40px;
          .infoTitle {
            color: #252525;
            font-size: 18px;
            font-weight: bold;
            height: 20px;
            line-height: 20px;
            padding-left: 10px;
            border-left: 5px #44be86 solid;
          }
          .list {
            margin-top: 25px;
            li {
              margin-bottom: 32px;
              a {
                display: block;
                h4 {
                  font-size: 14px;
                  color: #252525;
                  line-height: 20px;
                  margin-bottom: 10px;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  overflow: hidden;
                }
                h5 {
                  height: 16px;
                  font-size: 12px;
                  color: rgba(153, 153, 153, 1);
                  line-height: 16px;
                }
              }
            }
          }
        }
      }
    }
  }
}

/*!
 * Quill Editor v1.3.6
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
.ql-container {
  box-sizing: border-box;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 13px;
  height: 100%;
  margin: 0px;
  position: relative;
}
.ql-container.ql-disabled .ql-tooltip {
  visibility: hidden;
}
.ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {
  pointer-events: none;
}
.ql-clipboard {
  left: -100000px;
  height: 1px;
  overflow-y: hidden;
  position: absolute;
  top: 50%;
}
.ql-clipboard p {
  margin: 0;
  padding: 0;
}
.ql-editor {
  box-sizing: border-box;
  line-height: 1.42;
  height: 100%;
  outline: none;
  overflow-y: auto;
  padding: 12px 15px;
  tab-size: 4;
  -moz-tab-size: 4;
  text-align: left;
  white-space: pre-wrap;
  word-wrap: break-word;
}
.ql-editor > * {
  cursor: text;
}
.ql-editor p,
.ql-editor ol,
.ql-editor ul,
.ql-editor pre,
.ql-editor blockquote,
.ql-editor h1,
.ql-editor h2,
.ql-editor h3,
.ql-editor h4,
.ql-editor h5,
.ql-editor h6 {
  margin: 0;
  padding: 0;
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor ol,
.ql-editor ul {
  padding-left: 1.5em;
}
.ql-editor ol > li,
.ql-editor ul > li {
  list-style-type: none;
}
.ql-editor ul > li::before {
  content: "\2022";
}
.ql-editor ul[data-checked="true"],
.ql-editor ul[data-checked="false"] {
  pointer-events: none;
}
.ql-editor ul[data-checked="true"] > li *,
.ql-editor ul[data-checked="false"] > li * {
  pointer-events: all;
}
.ql-editor ul[data-checked="true"] > li::before,
.ql-editor ul[data-checked="false"] > li::before {
  color: #777;
  cursor: pointer;
  pointer-events: all;
}
.ql-editor ul[data-checked="true"] > li::before {
  content: "\2611";
}
.ql-editor ul[data-checked="false"] > li::before {
  content: "\2610";
}
.ql-editor li::before {
  display: inline-block;
  white-space: nowrap;
  width: 1.2em;
}
.ql-editor li:not(.ql-direction-rtl)::before {
  margin-left: -1.5em;
  margin-right: 0.3em;
  text-align: right;
}
.ql-editor li.ql-direction-rtl::before {
  margin-left: 0.3em;
  margin-right: -1.5em;
}
.ql-editor ol li:not(.ql-direction-rtl),
.ql-editor ul li:not(.ql-direction-rtl) {
  padding-left: 1.5em;
}
.ql-editor ol li.ql-direction-rtl,
.ql-editor ul li.ql-direction-rtl {
  padding-right: 1.5em;
}
.ql-editor ol li {
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  counter-increment: list-0;
}
.ql-editor ol li:before {
  content: counter(list-0, decimal) ". ";
}
.ql-editor ol li.ql-indent-1 {
  counter-increment: list-1;
}
.ql-editor ol li.ql-indent-1:before {
  content: counter(list-1, lower-alpha) ". ";
}
.ql-editor ol li.ql-indent-1 {
  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-2 {
  counter-increment: list-2;
}
.ql-editor ol li.ql-indent-2:before {
  content: counter(list-2, lower-roman) ". ";
}
.ql-editor ol li.ql-indent-2 {
  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-3 {
  counter-increment: list-3;
}
.ql-editor ol li.ql-indent-3:before {
  content: counter(list-3, decimal) ". ";
}
.ql-editor ol li.ql-indent-3 {
  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-4 {
  counter-increment: list-4;
}
.ql-editor ol li.ql-indent-4:before {
  content: counter(list-4, lower-alpha) ". ";
}
.ql-editor ol li.ql-indent-4 {
  counter-reset: list-5 list-6 list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-5 {
  counter-increment: list-5;
}
.ql-editor ol li.ql-indent-5:before {
  content: counter(list-5, lower-roman) ". ";
}
.ql-editor ol li.ql-indent-5 {
  counter-reset: list-6 list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-6 {
  counter-increment: list-6;
}
.ql-editor ol li.ql-indent-6:before {
  content: counter(list-6, decimal) ". ";
}
.ql-editor ol li.ql-indent-6 {
  counter-reset: list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-7 {
  counter-increment: list-7;
}
.ql-editor ol li.ql-indent-7:before {
  content: counter(list-7, lower-alpha) ". ";
}
.ql-editor ol li.ql-indent-7 {
  counter-reset: list-8 list-9;
}
.ql-editor ol li.ql-indent-8 {
  counter-increment: list-8;
}
.ql-editor ol li.ql-indent-8:before {
  content: counter(list-8, lower-roman) ". ";
}
.ql-editor ol li.ql-indent-8 {
  counter-reset: list-9;
}
.ql-editor ol li.ql-indent-9 {
  counter-increment: list-9;
}
.ql-editor ol li.ql-indent-9:before {
  content: counter(list-9, decimal) ". ";
}
.ql-editor .ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 1em;
}
.ql-editor li.ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 4.5em;
}
.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 3em;
}
.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 4.5em;
}
.ql-editor .ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 6em;
}
.ql-editor li.ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 7.5em;
}
.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 6em;
}
.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 7.5em;
}
.ql-editor .ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 9em;
}
.ql-editor li.ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 10.5em;
}
.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 9em;
}
.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 10.5em;
}
.ql-editor .ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 12em;
}
.ql-editor li.ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 13.5em;
}
.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 12em;
}
.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 13.5em;
}
.ql-editor .ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 15em;
}
.ql-editor li.ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 16.5em;
}
.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 15em;
}
.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 16.5em;
}
.ql-editor .ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 18em;
}
.ql-editor li.ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 19.5em;
}
.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 18em;
}
.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 19.5em;
}
.ql-editor .ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 21em;
}
.ql-editor li.ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 22.5em;
}
.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 21em;
}
.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 22.5em;
}
.ql-editor .ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 24em;
}
.ql-editor li.ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 25.5em;
}
.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 24em;
}
.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 25.5em;
}
.ql-editor .ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 27em;
}
.ql-editor li.ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 28.5em;
}
.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 27em;
}
.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 28.5em;
}
.ql-editor .ql-video {
  display: block;
  max-width: 100%;
}
.ql-editor .ql-video.ql-align-center {
  margin: 0 auto;
}
.ql-editor .ql-video.ql-align-right {
  margin: 0 0 0 auto;
}
.ql-editor .ql-bg-black {
  background-color: #000;
}
.ql-editor .ql-bg-red {
  background-color: #e60000;
}
.ql-editor .ql-bg-orange {
  background-color: #f90;
}
.ql-editor .ql-bg-yellow {
  background-color: #ff0;
}
.ql-editor .ql-bg-green {
  background-color: #008a00;
}
.ql-editor .ql-bg-blue {
  background-color: #06c;
}
.ql-editor .ql-bg-purple {
  background-color: #93f;
}
.ql-editor .ql-color-white {
  color: #fff;
}
.ql-editor .ql-color-red {
  color: #e60000;
}
.ql-editor .ql-color-orange {
  color: #f90;
}
.ql-editor .ql-color-yellow {
  color: #ff0;
}
.ql-editor .ql-color-green {
  color: #008a00;
}
.ql-editor .ql-color-blue {
  color: #06c;
}
.ql-editor .ql-color-purple {
  color: #93f;
}
.ql-editor .ql-font-serif {
  font-family: Georgia, Times New Roman, serif;
}
.ql-editor .ql-font-monospace {
  font-family: Monaco, Courier New, monospace;
}
.ql-editor .ql-size-small {
  font-size: 0.75em;
}
.ql-editor .ql-size-large {
  font-size: 1.5em;
}
.ql-editor .ql-size-huge {
  font-size: 2.5em;
}
.ql-editor .ql-direction-rtl {
  direction: rtl;
  text-align: inherit;
}
.ql-editor .ql-align-center {
  text-align: center;
}
.ql-editor .ql-align-justify {
  text-align: justify;
}
.ql-editor .ql-align-right {
  text-align: right;
}
.ql-editor.ql-blank::before {
  color: rgba(0, 0, 0, 0.6);
  content: attr(data-placeholder);
  font-style: italic;
  left: 15px;
  pointer-events: none;
  position: absolute;
  right: 15px;
}

.ql-picker-item[data-value="10px"]::before,
.ql-picker-label[data-value="10px"]::before {
  content: "10px" !important;
}

.ql-picker-item[data-value="12px"]::before,
.ql-picker-label[data-value="12px"]::before {
  content: "12px" !important;
}

.ql-picker-item[data-value="14px"]::before,
.ql-picker-label[data-value="14px"]::before {
  content: "14px" !important;
}

.ql-picker-item[data-value="16px"]::before,
.ql-picker-label[data-value="16px"]::before {
  content: "16px" !important;
}

.ql-picker-item[data-value="18px"]::before,
.ql-picker-label[data-value="18px"]::before {
  content: "18px" !important;
}

.ql-picker-item[data-value="20px"]::before,
.ql-picker-label[data-value="20px"]::before {
  content: "20px" !important;
}

.ql-picker-item[data-value="24px"]::before,
.ql-picker-label[data-value="24px"]::before {
  content: "24px" !important;
}

.ql-picker-item[data-value="30px"]::before,
.ql-picker-label[data-value="30px"]::before {
  content: "30px" !important;
}

.ql-picker-item[data-value="32px"]::before,
.ql-picker-label[data-value="32px"]::before {
  content: "32px" !important;
}

.ql-picker-item[data-value="36px"]::before,
.ql-picker-label[data-value="36px"]::before {
  content: "36px" !important;
}

.ql-picker.ql-lineheight {
  width: 58px;
}

.ql-picker.ql-lineheight .ql-picker-item[data-value="1"]::before {
  content: "1";
}
.ql-picker.ql-lineheight .ql-picker-label[data-value="1"]::before {
  content: "1" !important;
}
.ql-picker.ql-lineheight .ql-picker-item[data-value="1.2"]::before {
  content: "1.2";
}
.ql-picker.ql-lineheight .ql-picker-label[data-value="1.2"]::before {
  content: "1.2" !important;
}
.ql-picker.ql-lineheight .ql-picker-item[data-value="1.5"]::before {
  content: "1.5";
}
.ql-picker.ql-lineheight .ql-picker-label[data-value="1.5"]::before {
  content: "1.5" !important;
}
.ql-picker.ql-lineheight .ql-picker-item[data-value="1.6"]::before {
  content: "1.6";
}
.ql-picker.ql-lineheight .ql-picker-label[data-value="1.6"]::before {
  content: "1.6" !important;
}
.ql-picker.ql-lineheight .ql-picker-item[data-value="1.8"]::before {
  content: "1.8";
}
.ql-picker.ql-lineheight .ql-picker-label[data-value="1.8"]::before {
  content: "1.8" !important;
}
.ql-picker.ql-lineheight .ql-picker-item[data-value="2"]::before {
  content: "2";
}
.ql-picker.ql-lineheight .ql-picker-label[data-value="2"]::before {
  content: "2" !important;
}
.ql-picker.ql-lineheight .ql-picker-item[data-value="2.4"]::before {
  content: "2.4";
}
.ql-picker.ql-lineheight .ql-picker-label[data-value="2.4"]::before {
  content: "2.4" !important;
}
.ql-picker.ql-lineheight .ql-picker-item[data-value="2.8"]::before {
  content: "2.8";
}
.ql-picker.ql-lineheight .ql-picker-label[data-value="2.8"]::before {
  content: "2.8" !important;
}
.ql-picker.ql-lineheight .ql-picker-item[data-value="3"]::before {
  content: "3";
}
.ql-picker.ql-lineheight .ql-picker-label[data-value="3"]::before {
  content: "3" !important;
}
.ql-picker.ql-lineheight .ql-picker-item[data-value="4"]::before {
  content: "4";
}
.ql-picker.ql-lineheight .ql-picker-label[data-value="4"]::before {
  content: "4" !important;
}
.ql-picker.ql-lineheight .ql-picker-item[data-value="5"]::before {
  content: "5";
}
.ql-picker.ql-lineheight .ql-picker-label[data-value="5"]::before {
  content: "5" !important;
}
</style>
